import { BP_SCOPE } from '@bp/pim-auth-constants';
import { Capacitor } from '@capacitor/core';
import { type AsyncStorage, type INavigator, UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { STORAGE_KEY } from 'utils/constants';
import { isIosOrAndroid } from 'utils/isIosOrAndroid';

// singleton instance of UserManager
export class BpUserManager {
  private userManager: UserManager | null = null;

  setUserManager(store: AsyncStorage | Storage, navigator?: INavigator) {
    if (!this.userManager) {
      const currentPlatform = Capacitor.getPlatform();

      this.userManager = new UserManager(
        {
          stateStore: new WebStorageStateStore({
            store: store,
            prefix: STORAGE_KEY,
          }),
          automaticSilentRenew: true,
          loadUserInfo: true,
          includeIdTokenInSilentSignout: false,
          includeIdTokenInSilentRenew: false,
          authority: import.meta.env.VITE_APP_AUTH_SERVER_URI,
          staleStateAgeInSeconds: 60 * 60 * 24,
          client_id: isIosOrAndroid(currentPlatform)
            ? import.meta.env.VITE_APP_MOBILE_AUTH_CLIENT_ID
            : import.meta.env.VITE_APP_AUTH_CLIENT_ID,
          redirect_uri: isIosOrAndroid(currentPlatform)
            ? import.meta.env.VITE_APP_MOBILE_REDIRECT_URI
            : import.meta.env.VITE_APP_REDIRECT_URI,
          post_logout_redirect_uri: isIosOrAndroid(currentPlatform)
            ? import.meta.env.VITE_APP_MOBILE_LOGOUT_REDIRECT_URI
            : import.meta.env.VITE_APP_LOGOUT_REDIRECT_URI,
          prompt: 'consent',
          scope: ['email', 'openid', 'offline_access', BP_SCOPE].join(' '),
        },
        navigator,
      );
    }
    return this.userManager;
  }

  getUserManager() {
    if (!this.userManager) {
      throw new Error('UserManager not initialized');
    }
    return this.userManager;
  }
}
